export default function breadCrumbProcessor(route: string) {
  switch (route) {
    case '/visitor_log':
      return {
        desc: ['Home', 'Visitor Log'],
        routes: ['/'],
      };
    case '/setup':
      return {
        desc: ['Home', 'Setup'],
        routes: ['/'],
      };
    case '/red_zone_analysis':
      return {
        desc: ['Home', 'Red Zone'],
        routes: ['/'],
      };
    case '/lockup_report':
      return {
        desc: ['Home', 'Lockup Report'],
        routes: ['/'],
      };

    case '/incident_report':
      return {
        desc: ['Home', 'Red Zone'],
        routes: ['/'],
      };

    case '/systems_check':
      return {
        desc: ['Home', 'Systems Check'],
        routes: ['/'],
      };

    case '/disaster_notification':
      return {
        desc: ['Home', 'Disaster Notification'],
        routes: ['/'],
      };

    case '/protectee_research':
      return {
        desc: ['Home', 'Disaster Notification'],
        routes: ['/'],
      };
    case '/background_check':
      return {
        desc: ['Home', 'Background Check'],
        routes: ['/'],
      };

    case '/travel_advisory':
      return {
        desc: ['Home', 'Travel Advisory'],
        routes: ['/'],
      };
    default:
      return {
        desc: ['Home', ''],
        routes: ['/'],
      };
  }
}
